"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_1 = require("graphql");
function removeFields(query, fieldstoRemove) {
    return graphql_1.visit(query, {
        // tslint:disable-next-line:function-name
        Field: {
            enter: function (node) {
                return fieldstoRemove.indexOf(node.name.value) > -1 ? null : undefined;
            }
        }
    });
}
exports.removeFields = removeFields;
//# sourceMappingURL=remove-fields.js.map